import { AxiosResponse } from "axios";
import toast from "react-hot-toast";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";

import { RequestTypes } from "../types";
import { updatePlanByIdFailure, updatePlanByIdSuccess } from "../slices/features/planById";

const plansService = new AppService();

function* updatePlanById(action: any) {
  const { payload } = action;
  const { id, data } = payload;

  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      plansService.updatePlanByIdRequest,
      baseUrl,
      id,
      data
    );

    yield put(updatePlanByIdSuccess({ ...response }));

    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const {
      data: {
        errors: { message },
      },
    } = error;

    payload?.cbFailure && payload?.cbFailure(message);
    toast.error(Array.isArray(message) ? message[0] : message);

    yield put(updatePlanByIdFailure({ statusCode, statusText }));
  }
}

export function* watchUpdatePlanById() {
  yield takeLatest(RequestTypes.UPDATE_PLAN_BY_ID_REQUEST, updatePlanById);
}
